








































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { fetchDevoluciones } from './fetchDevoluciones';

import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { camposReportes } from '@/pantallas/Conecta/Devoluciones/camposReportes';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ValueFormatterParams,
  GetQuickFilterTextParams,
} from 'ag-grid-community';

import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    DatePicker,
    MantenedorGridSinCodigo,
    MantenedorGrid,
    Confirmation,
  },
})
export default class ComponenteDialogoReporteTecnico extends Vue {
  constructor() {
    super();
    actionsEvent.onEliminar(this.handleEliminar);
    actionsEvent.onEditarReporteTecnico(this.handleEditarRep);
  }

  @Prop({ default: '' }) num: any;
  @Prop({ default: true }) mostrarBtnCrear: boolean;
  @Prop({ default: '' }) accion: string;
  @Prop({ default: () => ({}) }) anulado: any;
  info: any = [];
  tecnicosOptions: any = [];
  estadosOptions: any = [];

  mostrarModal = false;
  mostrarModalEliminacion = false;
  devoLineaEliminacion = 0;
  abrirModalEditar = false;

  numeroDevolucion = '';

  devoLinea = 1;
  devoRepoFecha: any = null;
  devoObs = '';
  tecnico: any = '';
  devoRepoEstado: any = '';

  devoLineaEdit = 1;
  devoRepoFechaEdit = moment();
  devoObsEdit = '';
  tecnicoEdit: any = '';
  devoRepoEstadoEdit: any = '';

  devolucionAnulada = false;

  userID = JSON.parse(localStorage.getItem('user')).id;
  userRUT = JSON.parse(localStorage.getItem('user')).rutClienteDefecto;
  moduloID = Funcionalidades.Devoluciones;

  loadingService = new LoadingService();
  $snotify: any;

  beforeMount() {
    this.getTecnicos();
    this.getEstados();
    this.numeroDevolucion = this.num;
    this.devolucionAnulada =
      this.anulado.devoanuladesc == 'ANULADO' ||
      this.anulado.devoanuladesc == 'FINALIZADO';
  }

  getReportes() {
    this.loadingService.showLoading(undefined, 'getReportes');
    let payload =
      this.numeroDevolucion != ''
        ? { devoNum: this.numeroDevolucion }
        : { '': '' };
    return fetchDevoluciones('getReportes', payload)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          if (data.data.data.hasOwnProperty('LISTA'))
            this.info = data.data.data.LISTA;
          else this.info = [data.data.data];
          if (data.data.data.STATUS === 'SIN_DATA') {
            this.$snotify.warning('Sin registros de Reportes Técnicos', {
              timeout: 3000,
            });
            this.info = [];
          }
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.loadingService.hideLoading('getReportes');
        this.gridApi.setRowData(this.info);
        this.gridApi.setDomLayout('autoHeight');
        this.info.forEach((r: any) =>
          r.devolinea
            ? (this.devoLinea = Number(r.devolinea) + 1)
            : (this.devoLinea = 1)
        );
      });
  }

  getTecnicos() {
    this.loadingService.showLoading(undefined, 'getTecnicos');
    return fetchDevoluciones('getTecnicos', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          if (data.data.data.hasOwnProperty('LISTA'))
            this.tecnicosOptions = data.data.data.LISTA;
          else this.tecnicosOptions = [data.data.data];
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.tecnicosOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getTecnicos'));
  }

  getEstados() {
    this.loadingService.showLoading(undefined, 'getEstados');
    return fetchDevoluciones('opcionesEstadoReportes', { '': '' })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.estadosOptions = data.data.data;
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.estadosOptions = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getEstados'));
  }

  ingresarReporte() {
    this.loadingService.showLoading(undefined, 'ingresarReporte');
    let objParaIngresar = {
      devoNum: this.numeroDevolucion,
      devoLinea: this.devoLinea,
      devoRepoFecha: this.devoRepoFecha,
      devoObs: this.devoObs,
      tecnicoID: this.tecnico.tecnicoid,
      devoRepoEstado: this.devoRepoEstado.configid,
      userID: this.userID,
      userRUT: this.userRUT,
      moduloID: this.moduloID,
    };
    return fetchDevoluciones('ingresarReporte', objParaIngresar)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.devoLinea = 1;
          this.devoRepoFecha = null;
          this.devoObs = '';
          this.tecnico = '';
          this.devoRepoEstado = '';
          this.mostrarModal = false;
          this.getReportes();
        } else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('ingresarReporte'));
  }

  handleEditarRep(e: any) {
    this.abrirModalEditar = true;
    this.mostrarModal = false;
    this.tecnicoEdit = e.data.tecniconame;
    this.devoRepoEstadoEdit = e.data.devorepoestado == 1 ? 'OK' : 'NOK';
    this.devoRepoFechaEdit = moment(e.data.devorepofecha);
    this.devoObsEdit = e.data.devorepoobs;
    this.devoLineaEdit = e.data.devolinea;
  }

  editarReporte() {
    let objEdicionRepo: any = {
      devonum: this.numeroDevolucion,
      devolinea: this.devoLineaEdit,
      devorepoobs: this.devoObsEdit,
      devorepofecha: this.devoRepoFechaEdit,
      userID: this.userID,
      userRUT: this.userRUT,
      moduloID: this.moduloID,
    };
    if (this.devoRepoEstadoEdit.configid)
      objEdicionRepo['devorepoestado'] = this.devoRepoEstadoEdit.configid;
    if (this.tecnicoEdit.tecnicoid)
      objEdicionRepo['tecnicoid'] = this.tecnicoEdit.tecnicoid;
    this.loadingService.showLoading(undefined, 'editarReporte');
    return fetchDevoluciones('editarReporte', objEdicionRepo)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.loadingService.hideLoading('editarReporte');
        this.mostrarModal = false;
        this.abrirModalEditar = false;
        this.getReportes();
      });
  }

  handleEliminar(e: any) {
    this.mostrarModalEliminacion = true;
    this.devoLineaEliminacion = e.data.devolinea;
  }

  eliminarReporte(respuesta: any) {
    if (respuesta) {
      this.loadingService.showLoading(undefined, 'eliminarReporte');
      return fetchDevoluciones('eliminarReporte', {
        devonum: this.numeroDevolucion,
        devolinea: this.devoLineaEliminacion,
        userID: this.userID,
        userRUT: this.userRUT,
        moduloID: this.moduloID,
      })
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1')
            this.$snotify.success(data.data.MENSAJE_RESPUESTA, {
              timeout: 3000,
            });
          else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
        })
        .catch((err: any) => console.error(err))
        .finally(() => {
          this.loadingService.hideLoading('eliminarReporte');
          this.mostrarModalEliminacion = false;
          this.devoLineaEliminacion = 0;
          this.getReportes();
        });
    } else {
      this.mostrarModalEliminacion = false;
      this.devoLineaEliminacion = 0;
    }
  }

  // tabla //
  gridApi: GridApi = null;
  enrichedGridOptions: GridOptions = null;
  readonly funcionalidad: Funcionalidades = Funcionalidades.ReportesTecnicos;
  readonly gridOptions: GridOptions = {
    columnDefs: camposReportes,
    onGridReady: this.handleGridReady,
    isExternalFilterPresent: this.isExternalFilterPresent,
    doesExternalFilterPass: this.doesExternalFilterPass,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };
  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    await this.getReportes();
  }
  fechaValueFormatter(params: ValueFormatterParams) {
    return this.formatFecha(params.value);
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  fechaQuickFilterGetter(params: GetQuickFilterTextParams) {
    return this.formatFecha(params.value);
  }
  handleBusqueda() {
    this.gridApi.onFilterChanged();
  }
  doesExternalFilterPass(): boolean {
    return true;
  }
  isExternalFilterPresent(): boolean {
    return true;
  }
  // fin tabla //

  get fechaMaxima() {
    const hoy = new Date();
    let fechaMax =
      hoy.getFullYear() +
      '-' +
      this.dosCifras((hoy.getMonth() + 1).toString()) +
      '-' +
      this.dosCifras(hoy.getDate().toString());
    return fechaMax;
  }

  dosCifras(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }

  @Watch('num')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    if (value != oldValue) this.getReportes();
  }
}
